/**
 * StringUtils
 */

export class StringUtils {
  static isUndefinedOrNullOrEmpty(str: string | undefined | null): boolean {
    if (str === undefined) return true;
    if (str === null) return true;
    if (str.length === 0) return true;
    return false;
  }

  static isNotUndefinedOrNullOrEmpty(str: string | undefined | null): boolean {
    if (str === undefined) return false;
    if (str === null) return false;
    if (str.length === 0) return false;
    return true;
  }

  static isNumber(str: string | undefined | null): boolean {
    if (str === undefined) return false;
    if (str === null) return false;
    if (str.length === 0) return false;
    return !isNaN(Number(str));
  }
}